// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1WE5M","label":"LabeledBox_label__28j8A"};